import React from "react";
import styles from "./SelectionCard.module.scss";

interface SelectionCardProps {
  variant?: "square" | "circle";
  checked: boolean;
  text: string;
  secondaryText?: string;
  onClick?: () => void;
  fieldId?: string;
  style?: React.CSSProperties;
}

export default function SelectionCard({
  text,
  secondaryText,
  variant = "square",
  checked = false,
  onClick,
  fieldId,
  style,
}: SelectionCardProps) {
  return (
    <label style={style} htmlFor={fieldId} onClick={onClick} className={`${styles.selectionCard}`}>
      <div className={styles.textArea}>
        <p style={{ fontWeight: 400, flexGrow: 1 }}>{text}</p>
        {secondaryText ? <p className={styles.secondaryText}>{secondaryText}</p> : null}
      </div>
      <div
        style={{ position: "relative" }}
        className={`${styles.checkArea} ${styles[variant]} ${checked ? styles.checked : ""}`}
      >
        {checked && variant === "square" ? (
          <svg
            style={{ position: "absolute", top: "3px", left: "1px" }}
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.08203 3.36842L4.35031 6.56354L8.6585 0.705811" stroke="#222221" stroke-width="1.5" />
          </svg>
        ) : null}
      </div>
    </label>
  );
}
